import React, { useEffect, useRef, useState } from 'react';
import videojs, { VideoJsPlayer } from 'video.js';
import styles from './video.less';

interface IVideoProps {
  url?: string;
  jobId?: string;
  poster?: string;
  autoHeight?: boolean;
  getVideo?: (val: any) => void
}

const Video: React.FC<IVideoProps> = ({ url, jobId, poster, getVideo, autoHeight = false }) => {
  const [currentPoster] = useState(poster)
  const [player, setPlayer] = useState<VideoJsPlayer>()
  const [showPoster, setShowPoster] = useState(true)
  const videoRef = useRef<any>()

  useEffect(() => {
    if (!currentPoster) {
      initUrl()
    }
  }, [])

  const initUrl = () => {
    const videoNode = videoRef.current
    const player = videojs(videoNode, {
      language: 'zh-CN',
      controls: true,
      preload: 'auto',
      width: videoNode?.offsetWidth,
      ...(autoHeight ? {} : { height: videoNode?.offsetHeight }),
      sources: [
        {
          src: url!,
        },
      ],
    }, function onPlayerReady() {
      getVideo && getVideo(videoRef.current)
      setPlayer(player)
      setTimeout(() => {
        if (currentPoster) {
          player.play()
        }
      })
    });
    player.on('play', () => {
      if (showPoster) {
        setShowPoster(false)
      }
    })
  }

  return (
    <div className={styles.index}>
      <video
        x5-video-player-type="h5"
        className="video-js"
        ref={videoRef}
        // src={url}
        controls
      />
      {showPoster && <div
        className={styles.poster}
        style={currentPoster ? {
          backgroundImage: `url(${currentPoster})`
        } : {}}
        onClick={() => {
          if (currentPoster) {
            initUrl()
          } else if (player) {
            player.play()
          }
          setShowPoster(false)
        }}
      >
        <div className={styles.btn} />
      </div>}
    </div>
  )
};

export default Video;